import { fetch } from '@atlassian/eoc-fetch';
export const fetchUiSettingsEndpoint = async () => {
  return fetch('/v1/logs');
};